import Cookie from './cookie';
import {SESSION_TOKEN_COOKIE_NAME, SESSION_TOKEN_COOKIE_PATH} from '../config/constants';

const cookieParams = {
    hostOnly: true,
    path: SESSION_TOKEN_COOKIE_PATH,
    sameSite: 'Lax',
    secure: true
};

const clearSessionToken = () => {
    Cookie.deleteCookie(SESSION_TOKEN_COOKIE_NAME, cookieParams);
};

const setSessionToken = (token) => {
    clearSessionToken();

    if (!token) {
        return false;
    }

    Cookie.setValue(SESSION_TOKEN_COOKIE_NAME, token, cookieParams);
    return true;
};

export {setSessionToken, clearSessionToken};
